(function() {
    const CartEvents = {
        add: "TLFREEGIFT:add",
        update: "TLFREEGIFT:update",
        change: "TLFREEGIFT:change",
        clear: "TLFREEGIFT:clear",
        mutate: "TLFREEGIFT:mutate",
    };

    const ShopifyCartURLs = [
        "/cart/add",
        "/cart/update",
        "/cart/change",
        "/cart/clear",
        "/cart/add.js",
        "/cart/update.js",
        "/cart/change.js",
        "/cart/clear.js",
        "/cart/add.js?upcart=1&opens_cart=maybe"
    ];

    function isShopifyCartURL(url) {
        if(url instanceof URL) url = url.href;
        if(typeof url == "object" && url.url) url = url.url;
        if (!url || url.includes("app=salepify")) return false;
        
        try {
            let path = url.split("/").pop();
                path = path.split("?").shift();
            return ShopifyCartURLs.includes(`/cart/${path}`);
        } catch (e) {
            console.log("Not a normal URL: ", e)
            return false;
        }
    }
    
    function updateType(url) {
        if (!url || url.includes("app=salepify")) return false;
        if (url.includes("cart/add")) {
            return "add";
        } else if (url.includes("cart/update")) {
            return "update";
        } else if (url.includes("cart/change")) {
            return "change";
        } else if (url.includes("cart/clear")) {
            return "clear";
        } else return false;
    }

    function dispatchEvent(url, detail) {
        if (typeof detail === "string") {
            try {
                detail = JSON.parse(detail);
            } catch (e) {
                console.log("Error: ", e)
            }
        }

        const type = updateType(url);
        switch (type) {
            case "add":
                window.dispatchEvent(new CustomEvent(CartEvents.add, {detail}));
                break;
            case "update":
                window.dispatchEvent(new CustomEvent(CartEvents.update, {detail}));
                break;
            case "clear":
                window.dispatchEvent(new CustomEvent(CartEvents.clear, {detail}));
                break;
            case "change":
                window.dispatchEvent(new CustomEvent(CartEvents.change, {detail}));
                break;
            default:
                break;
        }
    }

    async function getOtherPayItemData(originalData, parsedBody) {
        const lineItemData = parsedBody.variables?.input?.lines?.[0];
        const merchandiseId = lineItemData?.merchandiseId;
        const itemId = merchandiseId.split("/").pop();
        const itemDataRes = await window.tlFreeGiftOffer.storefrontApi.getVariantData(itemId);
        const itemData = itemDataRes?.node;

        const sellingPlanAllocation = originalData?.data?.result?.cart?.lines?.edges?.[0]?.node?.sellingPlanAllocation;
        return {
            id: itemId,
            price: parseFloat(itemData.price.amount) * window.tlFreeGiftOffer.currencyRate,
            quantity: lineItemData?.quantity ?? 1,
            productId: itemData.product.id.split("/").pop(),
            selling_plan: !!sellingPlanAllocation
        }
    }

    function hasSpecificCountryCondition(rule) {
        if (rule.advanced_conditions) {
            const advancedCondition = JSON.parse(rule.advanced_conditions);
            if (advancedCondition.specific_country) {
                return true
            }
        }

        return false;
    }

    async function processOtherPayGiftRules(originalData, parsedBody) {
        const giftLines = [];
        const discounts = [];
        const rules = window.tlFreeGiftOffer.rules;

        const currentItemsInCart = window.tlFreeGiftOffer.itemsInCart;
        const currentRuleIdMapGifts = window.tlFreeGiftOffer.ruleIdMapGifts;

        // fake itemsInOtherPay
        const itemsInOtherPayCart = new Map();
        const itemData = await getOtherPayItemData(originalData, parsedBody);
        itemsInOtherPayCart.set(itemData.id, itemData)

        // fake ruleIdMapGiftAddedByApp
        window.tlFreeGiftOffer.itemsInCart = itemsInOtherPayCart;
        window.tlFreeGiftOffer.ruleIdMapGifts = new Map();
        
        let shouldPushLocation = false;
        for ( const rule of rules ) {
            if (rule.auto_add_gift) {
                const { needToAdd, giftsToAdd } = await window.tlFreeGiftOffer.checkRuleCondition(rule);
                if(needToAdd){
                    for (const item of giftsToAdd) {
                        const giftLine = {
                            merchandiseId: `gid://shopify/ProductVariant/${item.id}`,
                            quantity: item.quantity,
                            attributes: Object.entries(item.properties || {}).map(([key, value]) => ({
                                key,
                                value: String(value)
                            }))
                        }
                        giftLines.push(giftLine);
                    }
                    discounts.push(rule.discount_code);
                }
            }

            if(hasSpecificCountryCondition(rule)) shouldPushLocation = true;
        }

        if (shouldPushLocation) {
            const { country, region } = await this.getIpInfo();
            
            if (!Array.isArray(parsedBody.variables.input.attributes)) {
                parsedBody.variables.input.attributes = [];
            }
            parsedBody.variables.input.attributes.push({
                key: window.tlFreeGiftOffer.constants.LOCATION_CART_ATTRIBUTE,
                value: `${country}-${region}`,
            });
        }

        parsedBody.variables.input.lines.push(...giftLines);
        parsedBody.variables.input.discountCodes = discounts;

        // Restore state before handling OtherPay 
        window.tlFreeGiftOffer.itemsInCart = currentItemsInCart;
        window.tlFreeGiftOffer.ruleIdMapGifts = currentRuleIdMapGifts;

        return parsedBody;
    }
 
    let tlFreeGiftOfferClone;
    let fetchClone = window.fetch;
    
    Object.defineProperty(window, "tlFreeGiftOffer", {
        get() {
            return tlFreeGiftOfferClone;
        },
        set(val) {
            if(val && !tlFreeGiftOfferClone) {
                tlFreeGiftOfferClone = val; 
                Object.defineProperty(window, "fetch", {
                    get() {
                        return fetchClone;
                    },
                    set(val) {
                        if(val.toString().includes("X-Start-Wallet-Checkout")) {
                            const originalFetch = window.fetch;
                            val = async function () {
                                const [resource, config] = [...arguments];

                                const headers = config?.headers || {};
                                const isOtherCreateCart = headers["X-Start-Wallet-Checkout"] === "true" && ["ShopPay", "BuyItNow"].includes(headers["X-Wallet-Name"]);
                                if(isOtherCreateCart){
                                    try {
                                        const parsedBody = JSON.parse(config.body);
                                        const isCartCreate = parsedBody.query?.includes("mutation cartCreate") && Array.isArray(parsedBody.variables?.input?.lines);

                                        if (!isCartCreate) {
                                            return originalFetch.apply(this, arguments);
                                        }
                                        const originalResponse = await originalFetch.apply(this, arguments);
                                        const cloneRes = originalResponse.clone();
                                        const originalData = await cloneRes.json();

                                        const newBody = await processOtherPayGiftRules(originalData, parsedBody);
                                        config.body = JSON.stringify(newBody);
                                    } catch (error) {
                                        console.error("Error injecting gift into OtherPay cartCreate:", error);
                                    }
                                    return originalFetch.apply(this, arguments);
                                }else if (isShopifyCartURL(resource) && config && config.body && config.body !== "{}") {
                                    window.tlFreeGiftOffer.cartHasChanged = true;
                                    const response = originalFetch.apply(this, arguments)

                                    response.then((res) => {
                                        res
                                            .clone()
                                            .json()
                                            .then((data) => window.tlFreeGiftOffer.updateCartData());
                                    });
                                    return response;
                                } else {
                                    return originalFetch(...arguments)
                                }
                            };

                            
                        }
                        fetchClone = val;
                    },
                    configurable: true
                });   
            }
        },
        configurable: true
    });
    
})();